import {cx} from "@emotion/css";
import {ReactComponent as SvgFile} from "assets/svg/file.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmFileIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgFile id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
